<template>
    <div class="step">
        <h2 class="group-title">Groups</h2>
        <div>
            <camp-pricing-create v-for="(pricing, index) of form.pricings"
                                 :key="pricing.id"
                                 class="camp-pricing"
                                 :pricing-id="pricing.id"
                                 :pricing-name="pricing.name"
                                 :pricing-grade-from="pricing.gradeFrom"
                                 :pricing-grade-to="pricing.gradeTo"
                                 :pricing-age-from="pricing.ageFrom"
                                 :pricing-age-to="pricing.ageTo"
                                 :pricing-time-from="pricing.timeFrom"
                                 :pricing-time-to="pricing.timeTo"
                                 :can-remove="form.pricings.length > 1"
                                 :form-valid="formValid"
                                 @input:name="setCampPricingName({ name: $event, id: pricing.id })"
                                 @input:time-to="setCampPricingTimeTo({ timeTo: $event, id: pricing.id })"
                                 @input:time-from="setCampPricingTimeFrom({ timeFrom: $event, id: pricing.id })"
                                 @input:grade-from="setCampPricingGradeFrom({ gradeFrom: $event, id: pricing.id })"
                                 @input:grade-to="setCampPricingGradeTo({ gradeTo: $event, id: pricing.id })"
                                 @input:age-from="setCampPricingAgeFrom({ ageFrom: $event, id: pricing.id })"
                                 @input:age-to="setCampPricingAgeTo({ ageTo: $event, id: pricing.id })"
                                 @range-validate="onRangeValidate($event, index)"
                                 @click="addCampPricing"
                                 @remove="removeCampPricing(pricing.id)">
            </camp-pricing-create>
        </div>
        <add-button @click="addCampPricing">Add another group</add-button>
    </div>
</template>

<script>
    import { mapMutations, mapGetters } from 'vuex';
    import * as Mutations from '@/store/modules/camp-form/mutations';
    import { FormMixin } from '@/mixins/FormMixin';

    export default {
        name: 'Step2',
        components: {
            CampPricingCreate: () => import(/* webpackChunkName: 'camps' */'./CampPricingCreate'),
            AddButton:         () => import('../../../controls/AddButton'),
        },
        mixins: [FormMixin],
        data() {
            return {
                validCampPricingRanges: []
            }
        },
        computed: {
            ...mapGetters({
                form: 'campCreationForm'
            }),
            stepValid() {
                return this.formValid && this.rangeListValid;
            },
            rangeListValid() {
                return this.validCampPricingRanges.every(isValid => isValid);
            }
        },
        watch: {
            stepValid: {
                handler() {
                    this.setValid(this.stepValid);
                },
                immediate: true
            }
        },
        methods: {
            ...mapMutations({
                addCampPricing: Mutations.CAMP_FORM_ADD_PRICING,
                removeCampPricing: Mutations.CAMP_FORM_REMOVE_PRICING,
                setCampPricingName: Mutations.CAMP_FORM_SET_PRICING_NAME,
                setCampPricingTimeFrom: Mutations.CAMP_FORM_SET_PRICING_TIME_FROM,
                setCampPricingTimeTo: Mutations.CAMP_FORM_SET_PRICING_TIME_TO,
                setCampPricingAgeFrom: Mutations.CAMP_FORM_SET_PRICING_AGE_FROM,
                setCampPricingAgeTo: Mutations.CAMP_FORM_SET_PRICING_AGE_TO,
                setCampPricingGradeTo: Mutations.CAMP_FORM_SET_PRICING_GRADE_TO,
                setCampPricingGradeFrom: Mutations.CAMP_FORM_SET_PRICING_GRADE_FROM,
                setValid: Mutations.CAMP_FORM_SET_FORM_VALID,
            }),
            onRangeValidate(isValid, index) {
                const newList = [...this.validCampPricingRanges];
                newList[index] = isValid;
                this.validCampPricingRanges = newList;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../../assets/colors";

    .step {
        padding: 50px 92px;
        background: $White;
        width: 100%;
        box-shadow: 0 0 20px 0 rgba(176, 186, 197, 0.15);
        @media screen and (max-width: 1200px){
            padding: 45px 50px 50px;
        }
        @media screen and (max-width: 991px) {
            padding: 40px 30px 45px;
        }
        @media screen and (max-width: 767px) {
            padding: 40px 20px;
        }
        .camp-pricing {
            &:not(:last-child) {
                margin-bottom: 40px;
                padding-bottom: 20px;
                border-bottom: 1px solid $ComplementaryBgTxtDarker;
            }
        }
        .group-title {
            margin-bottom: 30px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/main/pages/camp-form/Step2.vue